'use client';
import {
  formatDateStringToLocalVN,
  getFileBase64,
  getFileBuffer,
  mapModifiers,
  slugify,
} from '@/utils/funtion';
import pdfDownload from '@/assets/images/down-arrow.png';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { IReport } from '@/interfaces/report';
import Skeleton from '@/components/atoms/skeletons';
import Empty from '@/components/atoms/empty';
import useGetNewPlans from '@/helpers/useGetNewPlans';
import { useSelector } from 'react-redux';
import Link from 'antd/es/typography/Link';
import PermissionModal from '@/components/organisms/permission-modal';
import { Spin } from 'antd';
import AntImage from '@/components/atoms/image';
import { FaAngleRight } from 'react-icons/fa6';
import { checkDownloadStatus } from '@/services/apis/modules/plans';
import { mimeTypes } from '@/statics/static';
import RichTextEditor from '@/components/molecules/richEditor';
import { useUnauthorized } from '@/stores/context/unauthorized';

interface Ipops {
  reportList: any;
}
const EconomicReportsModule = (props: Ipops) => {
  const { reportList } = props;
  const { fetchNewPlan } = useGetNewPlans();
  const { handleOpenUnauthorized } = useUnauthorized();

  const userData = useSelector((state: any) => state.userData);
  const [base64Images, setBase64Images] = useState<{ [key: string]: string }>(
    {},
  );
  const [loadingImages, setLoadingImages] = useState(true);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState({
    loading: false,
    id: '',
  });
  const [viewingPDF, setViewingPDF] = useState({
    loading: false,
    id: '',
  });
  const [modal, setModal] = useState({
    open: false,
    title: '',
  });
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (reportList?.records) {
      loadBase64Images(reportList?.records);
    }
  }, [reportList?.records]);

  const loadBase64Images = async (reports: any[]) => {
    if (!Array.isArray(reports)) return;

    try {
      const imagePromises = reports?.map(async (item) => {
        const base64 = await getFileBase64(item?.thumbnail);

        const childrenBase64 = await Promise.all(
          (item?.children || []).map(async (i: any) => {
            const base64I = await getFileBase64(i?.thumbnail);
            return { id: i?.id, base64: base64I };
          }),
        );

        return [{ id: item?.id, base64 }, ...childrenBase64];
      });

      const results = await Promise.all(imagePromises);
      const flattenedResults = results.flat();

      const imagesMap = flattenedResults.reduce(
        (acc, cur) => {
          if (cur.id && cur.base64) {
            acc[cur.id] = cur.base64;
          }
          return acc;
        },
        {} as { [key: string]: string },
      );

      setBase64Images(imagesMap);
      setLoadingImages(false);
    } catch (error) {
      setLoadingImages(false);
    }
  };

  const handleDownload = async (i: any) => {
    if (downloading?.loading && downloading.id === i?.id) return;
    if (!userData?.user) {
      setModal({
        ...modal,
        title: 'Download báo cáo',
        open: true,
      });
      return;
    }

    const res = await checkDownloadStatus({
      type: 'analysis_report',
      groupData: 'analysis_report',
    });

    if (res?.data?.downLoadStatus && res.status) {
      if (i?.file_url) {
        setDownloading({ loading: true, id: i?.id });
        try {
          const fileExtension = i?.file_url.split('.').pop()?.toLowerCase();
          const fileBuffer = await getFileBuffer(i?.file_url);
          if (!fileBuffer) throw new Error('Không thể tải file');
          if (!mimeTypes[fileExtension])
            throw new Error('Định dạng file không được hỗ trợ');
          const blob = new Blob([fileBuffer], {
            type: mimeTypes[fileExtension],
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${i?.title}.${fileExtension}`);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } catch (error) {
          console.error(error);
        } finally {
          setDownloading({ loading: false, id: '' });
          fetchNewPlan();
        }
      }
    } else {
      if (res.key === 'unauthorized') {
        handleOpenUnauthorized();
      } else {
        setModal({
          ...modal,
          title: 'Download báo cáo',
          open: true,
        });
      }
    }
  };

  return (
    <div className={mapModifiers('p-report')}>
      <div className="p-report_wrapper">
        <div className="page-title">Tài nguyên</div>
        {reportList?.records?.map((item: IReport, index: number) => {
          return (
            <div
              className="p-report_outlook"
              key={index}
              id={index?.toString()}
            >
              <div className="p-report_outlook_heading">
                <Link
                  href={`/tai-nguyen/${slugify(item?.title)}?id=${item?.id}`}
                  className="p-report_outlook_heading_title"
                >
                  {item?.title}
                </Link>
                <Link
                  href={`/tai-nguyen/${slugify(item?.title)}?id=${item?.id}`}
                  className="p-report_outlook_heading_view-more"
                >
                  Xem thêm <FaAngleRight />
                </Link>
              </div>
              <div className="p-report_outlook_line"></div>
              {!loading && !loadingImages ? (
                !item?.children?.length ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      height: 267,
                      width: '100%',
                    }}
                  >
                    <Empty />
                  </div>
                ) : (
                  <div className="p-report_outlook_list">
                    {item?.children?.slice(0, 4)?.map((i, index: number) => {
                      const base64Image = base64Images[i?.id];
                      return (
                        <div className="p-report_outlook_list_card" key={index}>
                          <div className="p-report_outlook_list_card_heading">
                            <AntImage
                              src={`data:image/jpeg;base64,${base64Image}`}
                              alt="report"
                              preview
                            />
                            <div className="p-report_outlook_list_card_heading_name">
                              <p>{i.title}</p>
                              <p>
                                {formatDateStringToLocalVN(
                                  i?.created_at as string,
                                  'DD-MM-YYYY',
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="p-report_outlook_list_card_name">
                            {i.title}
                          </div>
                          <div className="p-report_outlook_list_card_desc">
                            <RichTextEditor data={i?.summary} isDisabled />
                          </div>
                          <div className="p-report_outlook_list_card_action">
                            <div
                              className={mapModifiers(
                                downloading?.loading && downloading.id === i?.id
                                  ? 'p-report_outlook_list_card_action-disable'
                                  : '',
                              )}
                              onClick={() => handleDownload(i)}
                            >
                              <Spin
                                spinning={
                                  downloading?.loading &&
                                  downloading.id === i?.id
                                }
                              >
                                <Image
                                  src={pdfDownload}
                                  alt="download pdf"
                                  width={50}
                                  height={50}
                                  loading="lazy"
                                />
                                <p>
                                  Tải xuống{' '}
                                  {i?.file_url
                                    ?.split('.')
                                    .pop()
                                    ?.toUpperCase() || ''}
                                </p>
                              </Spin>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )
              ) : (
                <div className="p-report_outlook_list">
                  {Array(4)
                    ?.fill(null)
                    .map((_, index) => (
                      <Skeleton
                        key={index}
                        active
                        type="default"
                        loading
                        paragraph={{ rows: 8, maxWidth: 1380, width: '100%' }}
                      />
                    ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <PermissionModal
        open={modal.open}
        onCancel={() => {
          setModal({
            title: '',
            open: false,
          });
        }}
        title={modal.title}
      />
    </div>
  );
};

export default EconomicReportsModule;
